import { insertAfter } from "./dom"

const FIELD_TOOLTIPS: ReadonlyArray<[selector: string, message: string]> = [
  [".first__name", "Enter your first name"],
  [".last__name", "Enter your last name"],
  ["#date", "You must be 18 to become a subscriber"],
  [".address1", "Your street address where we'll be providing electricity"],
  [".address2", "Apartment or suite number"],
  [".zip-code", "If you change the zipcode, we need to search again to make sure we have the right farm"],
  [".phone", "Area code + 7 digits"],
]

function attachTooltips(): void {
  for (const [selector, message] of FIELD_TOOLTIPS) {
    document.querySelectorAll(selector).forEach((field) => {
      field.addEventListener("focus", () => {
        const tip = document.createElement("span")
        tip.className = "tooltip"
        tip.textContent = message
        insertAfter(tip, field)
      })
      field.addEventListener("blur", () => {
        document.querySelectorAll("span.tooltip").forEach((t) => t.remove())
      })
    })
  }
}

function applyHoverVisibility(trigger: Element, target: Element | null): void {
  if (!target) return
  trigger.addEventListener("mouseenter", () => {
    ;(target as HTMLElement).style.visibility = "visible"
    ;(target as HTMLElement).style.opacity = "1"
    ;(target as HTMLElement).style.pointerEvents = "all"
  })
  trigger.addEventListener("mouseleave", () => {
    ;(target as HTMLElement).style.visibility = "hidden"
    ;(target as HTMLElement).style.opacity = "0"
    ;(target as HTMLElement).style.pointerEvents = "none"
  })
}

function attachHoverHints(): void {
  document.querySelectorAll(".zip-code img").forEach((img) => {
    applyHoverVisibility(img, document.querySelector(".zip-content"))
  })

  document.querySelectorAll(".inputWrapperForTool img").forEach((img) => {
    applyHoverVisibility(img, img.previousElementSibling)
  })
}

function attachSavePopup(): void {
  document.querySelector("button#save-remind")?.addEventListener("click", () => {
    document.body.classList.add("show__popup")
  })
  document.querySelector(".close-icon")?.addEventListener("click", () => {
    document.body.classList.remove("show__popup")
  })
}

function attachFloatingLabels(): void {
  document.querySelectorAll("input").forEach((input) => {
    const update = (): void => {
      if (input.value !== "") {
        input.parentElement?.classList.add("textExist")
      } else {
        input.parentElement?.classList.remove("textExist")
      }
    }
    input.addEventListener("keyup", update)
    input.addEventListener("keydown", update)
  })
}

function attachCheckboxLabels(): void {
  document.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
    const label = document.createElement("div")
    label.className = "label"
    insertAfter(label, checkbox)
  })
}

function attachPasswordToggle(): void {
  const toggle = document.querySelector("#haveOnlineAccountMainDiv i#togglePassword")
  toggle?.addEventListener("click", () => {
    toggle.classList.toggle("colored")
  })
}

function patchLgsiayForm(): void {
  document.querySelectorAll(".lgsiay-form form br").forEach((br) => br.remove())
  document.querySelectorAll(".lgsiay-form form input").forEach((input) => {
    const wrapper = document.createElement("div")
    wrapper.className = "tool-wrapper"
    input.parentNode?.insertBefore(wrapper, input)
    wrapper.appendChild(input)
  })
}

export function initFormEnhancements(): void {
  attachTooltips()
  attachHoverHints()
  attachSavePopup()
  attachFloatingLabels()
  attachCheckboxLabels()
  attachPasswordToggle()
  patchLgsiayForm()
}
